export function isIteratorNonEmpty<T>(iterator: Iterator<T>): boolean {
  return iterator.next().done === false;
}

export function firstInIterator<T>(iterator: Iterator<T>): T | null {
  const result = iterator.next();
  return result.done ? null : result.value;
}

export function* objectKeys<T extends object>(obj: T): Generator<keyof T> {
  for (const key in obj) {
    yield key;
  }
}

export function* objectEntries<T extends object>(
  obj: T,
): Generator<[keyof T, T[keyof T]]> {
  for (const key in obj) {
    yield [key, obj[key]];
  }
}

/**
 * @example
 * mapIterable(objectKeys(RENDER_MODE), (key) => RENDER_MODE[key]) // is an array
 */
export function mapIterable<T, U>(
  iterable: Iterable<T>,
  mapper: (item: T) => U,
): U[] {
  const result: U[] = [];
  for (const item of iterable) {
    result.push(mapper(item));
  }
  return result;
}

export function withoutUndefineds<T>(obj: T) {
  const next = {} as WithoutUndefineds<T>;
  for (const key in obj) {
    const val = obj[key];
    // @ts-expect-error typing difficulty
    if (val !== undefined) next[key] = val;
  }
  return next;
}
